import React, { useEffect } from 'react';
import { HelpCircle, Mail } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import PageHeader from '../common/PageHeader';
import Footer from '../common/Footer';

const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqs = [
    {
      question: "Vad händer om jag förstör dekalen när jag monterar?",
      answer: "Vi skickar en ny gratis om du följt instruktionerna. Ta bara en bild och kontakta oss inom 7 dagar. Plus: över 90% lyckas första gången med våra videoinstruktioner. Det är enklare än du tror!"
    },
    {
      question: "Kommer dekalen att skada min billack?",
      answer: "Nej. Vi använder 3M Cast vinyl med speciallim som är testat för bilanvändning. När du tar bort dekalen (även efter flera år) lossnar den rent utan att lämna märken eller skada lacken. Funkar på både matt och blank lack. Perfekt även för leasingbilar."
    },
    {
      question: "Hur länge håller dekalerna? Tål de biltvätt?",
      answer: "Minst 5 år utomhus med normal användning. Vi ger 5 års garanti. Ja, de tål både biltvätt och högtryckstvätt – bara undvik ångblåsare de första 48 timmarna efter montering. Materialet är UV-beständigt så färgerna blekar inte i solen."
    },
    {
      question: "Vad är vektorisering och varför kostar det extra?",
      answer: "Vanliga bilder (JPG, PNG) är gjorda av pixlar. När vi förstora dem till bilstorlek blir de suddiga och kantiga. Vektorisering är när vi omvandlar din bild till vektorformat – vilket betyder att den kan förstoras hur mycket som helst utan att tappa kvalitet. Resultatet blir kristallskarpt. Har du redan en vektoriserad fil (SVG, AI, PDF) är det gratis!"
    },
    {
      question: "Vad händer om jag inte är nöjd med slutresultatet?",
      answer: "Du får alltid ett digitalt korrektur innan vi trycker, så du ser exakt hur det blir. Om det ändå blir något produktionsfel, åtgärdar vi det direkt eller gör om trycket kostnadsfritt."
    },
    {
      question: "Min bilmodell finns inte i er lista, vad gör jag?",
      answer: "Kontakta oss så lägger vi till den! Ta en bild på sidan av bilen och maila till info@dekalio.nu. Vi gör en mall åt dig inom 2-3 arbetsdagar helt gratis. Vi lägger till nya bilmodeller varje vecka."
    },
    {
      question: "Hur lång är leveranstiden?",
      answer: "3-5 arbetsdagar från att du godkänt korrekturet. Vi skickar med PostNord med spårning. Behöver du det snabbare? Vi erbjuder express (1-2 dagar) för 500 kr extra. Beställ före kl 12 för samma dags produktion."
    },
    {
      question: "Kan jag lita på att designen i editorn blir exakt likadan i verkligheten?",
      answer: "Ja. Vår 3D-modell använder exakta mått från bilmodellerna. Det du ser är det du får – vi har kalibrerat färgerna mot våra tryckare. Plus: du får alltid ett digitalt korrektur att godkänna innan vi trycker."
    },
    {
      question: "Hur når jag er om jag har problem eller frågor?",
      answer: "Email: info@dekalio.nu (svarar inom 2 timmar på vardagar). Kontakta oss via chatten nere till höger för snabbast svar. Vi har svensktalande support som faktiskt kan svara på tekniska frågor. Inga automatiska svar."
    },
    {
      question: "Kan jag ha flera dekaler på samma bil?",
      answer: "Ja. Du designar hela bilen och kan placera flera dekaler på olika ytor."
    },
    {
      question: "Kan jag designa flera bilar?",
      answer: "Ja. Du kan skapa flera bilprojekt och anpassa varje bil separat."
    },
    {
      question: "Vad händer om paketet skadas under transport?",
      answer: "Alla paket är försäkrade. Ta en bild på skadan och kontakta oss direkt så skickar vi ett nytt paket samma dag. Du betalar ingenting extra. Vi hanterar allt med PostNord."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <PageHeader />

      <div className="container py-12 md:py-12">
        <div className="mx-auto flex max-w-[980px] flex-col items-center gap-4 text-center mb-16">
          <div className="mx-auto mb-4">
            <HelpCircle className="h-12 w-12 text-primary mx-auto mb-4" />
          </div>
          <Badge variant="outline">FAQ</Badge>
          <h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
            Vanliga frågor
          </h1>
          <p className="max-w-[750px] text-lg text-muted-foreground">
            Här hittar du svar på de vanligaste frågorna om våra bildekaler, leverans och material.
          </p>
        </div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border rounded-lg px-6">
                <AccordionTrigger className="text-left hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground mb-4">Fick du inte svar på din fråga?</p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Button asChild>
                <a href="mailto:info@dekalio.nu" className="flex items-center gap-2">
                  <Mail className="h-5 w-5" />
                  Skicka email
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQ;

